import React from 'react'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { ErrorMessage } from '@hookform/error-message'
import { requestPasswordReset } from '../../api/client'
import { AxiosError } from 'axios'

interface IProps {
  onSuccess?: () => void
}

const schema = yup
  .object()
  .shape({
    email: yup.string().required(),
  })
  .required()

// TODO: Network error state
const RecoverPasswordForm: React.FC<IProps> = ({ onSuccess }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({ resolver: yupResolver(schema) })

  const onSubmit = async ({ email }: any) => {
    try {
      const response = await requestPasswordReset(email)
      console.log(response)
      onSuccess?.()
    } catch (e) {
      if (e instanceof AxiosError) {
        alert(e.response?.data.error)
      }
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <label htmlFor={'email'} className={'label'}>
          Email Address:
        </label>
        <input
          {...register('email')}
          disabled={isSubmitting}
          type={'email'}
          className={'mt-1 input'}
        />
        <ErrorMessage
          errors={errors}
          name={'email'}
          render={({ message }) => (
            <span className={'input-error-text'}>{message}</span>
          )}
        />
      </div>
      <div className={'mt-4'}>
        <button className={'button w-full'} disabled={isSubmitting}>
          Send Password Reset Email
        </button>
      </div>
    </form>
  )
}

export default RecoverPasswordForm
